import React, { useCallback, useMemo } from "react";
import PostAddForm from "../../../../components/forms/postItemsForm/index";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SuccessNotify } from "../../../../constants/tostify";
import { FailedNotify } from "../../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
import { publishImage } from "../../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { decodeId } from "../../../../utils/idObfuscator";
import {
  useGetShopByIdQuery,
  useLazyGetShopCategoriesQuery,
  useCreateShopItemMutation,
} from "../../../../features/shop/shopApiSlice";

const RawMaterialPostAddForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isloading, setIsloading] = useState(false);
  const [displayimg, setDisplayimg] = useState();
  const { name } = useSelector((state) => state.user);
  const [shopCategory, setShopCategory] = useState([]);
  const [shopCategorytwo, setShopCategorytwo] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [parentCategory, setParentCategory] = useState("");
  const [data, setData] = useState({
    category: "",
    subCategory: "",
  });

  const [triggerGetCategories] = useLazyGetShopCategoriesQuery();
  const [createShopItem] = useCreateShopItemMutation();
  const cleanShopId = decodeId(id) || id || "";
  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, { skip: !cleanShopId });
  const shop = shopRes?.data?.Shop;

  const Handledata = (e) => {
    const raw = e.target.value || "";
    const dot = raw.indexOf(".");
    let idPart = raw;
    let namePart = "";
    if (dot !== -1) {
      idPart = raw.slice(0, dot);
      namePart = raw.slice(dot + 1);
      try {
        namePart = decodeURIComponent(namePart);
      } catch (_) {
        /* keep raw */
      }
    }
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: [idPart, namePart],
      ...(e.target.name === "category" ? { subCategory: "" } : {}),
    }));
    if (e.target.name === "category") {
      setShopCategorytwo([]);
    }
  };

  const categoryName = data?.category?.[1] || "";
  const categoryid = data?.category?.[0] || "";
  const subcategoryName = data?.subCategory?.[1] || "";
  const subcategoryid = data?.subCategory?.[0] || "";

  // Resolve parent from this shop
  useEffect(() => {
    const fromShop =
      shop?.shopCategory?.name ||
      shop?.shopCategory ||
      "";
    const fromStorage = localStorage.getItem("mycategory") || "";
    const resolved =
      (typeof fromShop === "string" && fromShop.trim()) ||
      (fromStorage &&
        fromStorage !== "undefined" &&
        fromStorage !== "null" &&
        fromStorage.trim()) ||
      "";

    setParentCategory(resolved);
  }, [shop]);

  const fetchCats = useCallback(
    async (type, parent) => {
      try {
        const response = await triggerGetCategories({
          type,
          parentCategory: parent ?? "",
        }).unwrap();
        if (response?.success && Array.isArray(response?.data?.Category)) {
          return response.data.Category;
        }
      } catch (_) {
        /* empty */
      }
      return [];
    },
    [triggerGetCategories],
  );

  const loadCategories = useCallback(
    async (parent) => {
      const parentKey = (parent || "").trim();

      // Shop category set → children under that supplier type
      if (parentKey) {
        const kids = await fetchCats("rawMaterialShop", parentKey);
        if (kids.length) {
          setShopCategory(kids);
          return;
        }
      }

      // Fallback: top-level raw material supplier categories
      const topLevel = await fetchCats("rawMaterialShop", "");
      setShopCategory(topLevel);
    },
    [fetchCats],
  );

  const loadSubCategories = useCallback(
    async (parentName) => {
      const parentKey = (parentName || "").trim();
      if (!parentKey) {
        setShopCategorytwo([]);
        return;
      }

      // Item-level under selected mid category (names often contain "&")
      let subs = await fetchCats("rawMaterialShopItem", parentKey);

      // If user picked a top-level supplier as category, show its mid-level kids
      if (!subs.length) {
        const mid = await fetchCats("rawMaterialShop", parentKey);
        if (mid.length) subs = mid;
      }

      setShopCategorytwo(subs);
    },
    [fetchCats],
  );

  useEffect(() => {
    loadCategories(parentCategory);
  }, [parentCategory, loadCategories]);

  useEffect(() => {
    if (categoryName) {
      loadSubCategories(categoryName);
    } else {
      setShopCategorytwo([]);
    }
  }, [categoryName, loadSubCategories]);

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setUserData((prev) => ({
        ...prev,
        images: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [userData, setUserData] = useState({
    businessType: "rawmaterialShop",
    userid: "",
    shopid: "",
    isSingleItem: false,
    isScrapItem: false,
    itemname: "",
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    price: "",
    country: "",
    city: "",
    state: "",
    quantity: "",
    unitOfMeasurement: "",
    currency: {
      currencyName: "",
    },
    images: [""],
    status: true,
  });

  useEffect(() => {
    setUserData((prev) => ({
      ...prev,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid,
    }));
  }, [categoryid, categoryName, subcategoryName, subcategoryid]);

  useEffect(() => {
    const resolvedUserId = shop?.userid?._id || shop?.userid || name?._id || "";
    const resolvedShopId = shop?._id || cleanShopId || id || "";
    if (!resolvedUserId && !resolvedShopId) return;

    const defaultCountry =
      shop?.resolvedCountry ||
      shop?.country ||
      shop?.userid?.address?.country ||
      shop?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      shop?.resolvedRegion ||
      shop?.state ||
      shop?.userid?.address?.state ||
      shop?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      shop?.resolvedCity ||
      shop?.city ||
      shop?.userid?.address?.city ||
      shop?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    setUserData((prev) => ({
      ...prev,
      userid: resolvedUserId || prev.userid,
      shopid: resolvedShopId || prev.shopid,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [shop, name, cleanShopId, id]);

  const FirstCategory = () => {
    loadCategories(parentCategory || localStorage.getItem("mycategory") || "");
  };

  const Mydata = () => {
    loadSubCategories(categoryName);
  };

  const userDatahandler = async (e) => {
    e.preventDefault();
    setIsloading(true);
    try {
      const response = await createShopItem({
        ...userData,
        userid: userData.userid || shop?.userid?._id || shop?.userid || name?._id,
        shopid: userData.shopid || shop?._id || cleanShopId || id,
        country: userData.country,
        state: userData.state,
        city: userData.city,
        businessType: "rawmaterialShop",
      }).unwrap();

      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Add Post Successfully");
        }, 1000);
        navigate(`/rawmaterial-owner-profile/${id}`);
      } else {
        FailedNotify("Failed To Post Try Again!");
      }
    } catch (err) {
      FailedNotify("Failed To Post Try Again!");
    } finally {
      setIsloading(false);
    }
  };

  const categoryOptions = useMemo(
    () => (Array.isArray(shopCategory) ? shopCategory : []),
    [shopCategory],
  );
  const subCategoryOptions = useMemo(
    () => (Array.isArray(shopCategorytwo) ? shopCategorytwo : []),
    [shopCategorytwo],
  );

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  return (
    <PostAddForm
      back="/rawmaterial-owner-profile/"
      butn="Post"
      postbtn="/rawmaterial-owner-profile"
      cancel="/rawmaterial-owner-profile"
      setUserData={setUserData}
      handlerFunction={userDatahandler}
      userData={userData}
      id={id}
      shopCategory={categoryOptions}
      shopCategorytwo={subCategoryOptions}
      Mydata={Mydata}
      Handledata={Handledata}
      data={data}
      getInputProps={getInputProps}
      getRootProps={getRootProps}
      displayimg={displayimg}
      setDisplayimg={setDisplayimg}
      FirstCategory={FirstCategory}
      isUploading={isUploading}
      uploadProgress={uploadProgress}
    />
  );
};

export default RawMaterialPostAddForm;
